export default __webpack_public_path__ + "static/media/shoulder.42be2096.webp";